import i18nCommons from 'i18next';
import React from 'react';
import { initReactI18next } from 'react-i18next';
import appStoreBadgeDe from '../assets/images/store-badges/app-store-de.svg';
import appStoreBadgeEn from '../assets/images/store-badges/app-store-en.svg';
import appStoreBadgeEs from '../assets/images/store-badges/app-store-es.svg';
import appStoreBadgeFr from '../assets/images/store-badges/app-store-fr.svg';
import googlePlayBadgeDe from '../assets/images/store-badges/google-play-de.png';
import googlePlayBadgeEn from '../assets/images/store-badges/google-play-en.png';
import googlePlayBadgeEs from '../assets/images/store-badges/google-play-es.png';
import googlePlayBadgeFr from '../assets/images/store-badges/google-play-fr.png';
import { EnglishIcon, FrenchIcon, GermanIcon, SpanishIcon } from '../components/icons/languages';
import deCommonsTranslations from './de.json';
import enCommonsTranslations from './en.json';
import esCommonsTranslations from './es.json';
import frCommonsTranslations from './fr.json';
export const languages = {
  en: {
    key: 'en',
    icon: /*#__PURE__*/React.createElement(EnglishIcon, null),
    label: 'English',
    translation: enCommonsTranslations
  },
  fr: {
    key: 'fr',
    icon: /*#__PURE__*/React.createElement(FrenchIcon, null),
    label: 'Français',
    translation: frCommonsTranslations
  },
  de: {
    key: 'de',
    icon: /*#__PURE__*/React.createElement(GermanIcon, null),
    label: 'Deutsch',
    translation: deCommonsTranslations
  },
  es: {
    key: 'es',
    icon: /*#__PURE__*/React.createElement(SpanishIcon, null),
    label: 'Español',
    translation: esCommonsTranslations
  }
};
export let navigatorLanguage;
if (typeof window !== 'undefined') {
  if (/^en\b/.test(navigator.language)) navigatorLanguage = 'en';else if (/^fr\b/.test(navigator.language)) navigatorLanguage = 'fr';else if (/^de\b/.test(navigator.language)) navigatorLanguage = 'de';else if (/^es\b/.test(navigator.language)) navigatorLanguage = 'es';
}
export const badgeUrls = {
  en: {
    android: googlePlayBadgeEn,
    ios: appStoreBadgeEn
  },
  fr: {
    android: googlePlayBadgeFr,
    ios: appStoreBadgeFr
  },
  de: {
    android: googlePlayBadgeDe,
    ios: appStoreBadgeDe
  },
  es: {
    android: googlePlayBadgeEs,
    ios: appStoreBadgeEs
  }
};
export let defaultLanguage = 'en';
try {
  if (typeof window !== 'undefined') defaultLanguage = localStorage.getItem('language') || navigatorLanguage && languages[navigatorLanguage]?.key || 'en';
} catch {
  console.error('localStorage access is denied');
}
i18nCommons.use(initReactI18next).init({
  resources: languages,
  lng: defaultLanguage,
  fallbackLng: 'en',
  debug: process.env.NODE_ENV === 'development',
  keySeparator: '.',
  interpolation: {
    escapeValue: false
  }
});
export const frenchProcessor = {
  type: 'postProcessor',
  name: 'frenchProcessor',
  process: function (value, _, options) {
    if (options.lng === 'fr') {
      return value.replace(' ?', '\u00a0?').replace(' !', '\u00a0!').replace(' :', '\u00a0:').replace(', ...', ',\u00a0...');
    }
    return value;
  }
};
export { i18nCommons, enCommonsTranslations, frCommonsTranslations, deCommonsTranslations, esCommonsTranslations };